import * as wheel from '@/api/games/wheel'
import * as spinners from '@/api/games/spinners'
import * as coinflip from '@/api/games/coinflip'
import * as cases from '@/api/games/cases'
import * as caseBattles from '@/api/games/case-battles'
import * as dice from '@/api/games/dice'

export * as app from '@/api/app'
export * as auth from '@/api/auth'
export * as user from '@/api/user'
export * as chat from '@/api/chat'
export * as items from '@/api/items'

export const games = {
  wheel,
  spinners,
  coinflip,
  cases,
  dice,
  caseBattles,
}
